import styled from 'styled-components';
import {
  Content,
  Group,
  Label,
  Root,
  Separator,
  Trigger,
} from '@radix-ui/react-dropdown-menu';

/**
 * Container of menu items/ListRows, visible when menu is open
 */
export const MenuContent = styled(Content)`
  background-color: var(--white);
  border-radius: 6px;
  box-shadow: var(--level-1);
`;

export const MenuHeading = styled(Label)`
  color: var(--pleather);
  cursor: default;
  font-weight: var(--bold);
  overflow: hidden;
  padding: 10px 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/**
 *  Visually distinct group of menu items
 */
export const MenuSection = styled(Group)`
  padding: 8px 4px;
`;

/**
 * Separates MenuSections
 */
export const MenuSeparator = styled(Separator)`
  border-bottom: 0;
  border-top: 1px solid var(--ui-vertical-separator);
`;

/** Contains the button which opens/closes the menu */
export const MenuTrigger = styled(Trigger)`
  &:focus-visible {
    outline-width: 0px;
  }
`;

/** Wrapper of the entire menu component, including trigger */
export const Menu = styled(Root)``;
